import { Tooltip } from '@foam/buoy/src/components/Tooltip/Tooltip';
import { cn } from '@foam/buoy/src/lib/utils';

import { BrandItem } from './BrandExperience';
import { BrandLogoImage } from './BrandLogoImage';

export interface BrandItemComponentProps {
  item: BrandItem;
  idx: number;
  className?: string;
}

export const BrandItemComponent = ({
  item,
  idx,
  className = '',
}: BrandItemComponentProps) => (
  <div
    key={`${item.alt}-${idx}`}
    className={cn(
      'flex h-40 items-center justify-center rounded-8 px-2',
      className,
    )}
  >
    <Tooltip content={item.alt} data-testid="content-tooltip">
      <BrandLogoImage
        item={item}
        className="size-auto max-h-20 max-w-32 object-contain"
      />
    </Tooltip>
  </div>
);
